<script setup lang="ts">
import { FormKitSchema } from '@formkit/vue'
import { computed } from 'vue'
import type { FormBuilder } from './useFormBuilder'

const { formBuilder } = defineProps<{ formBuilder: FormBuilder }>()
const schema = computed(() => formBuilder.toSchema())
</script>

<template>
    <div class="fb-preview">
        <div v-if="schema.length === 0" class="fb-preview__empty">
            <i class="fa fa-eye fa-2x"></i>
            <div class="mt-2">{{ $t("components:form_builder.preview_empty") }}</div>
        </div>
        <FormKit v-else type="form" :actions="false">
            <FormKitSchema :schema="schema" />
        </FormKit>
    </div>
</template>

<style lang="scss" scoped>
.fb-preview {
    padding: 1.5rem;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    min-height: 200px;

    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 160px;
        color: #ced4da;
        text-align: center;
    }
}
</style>
